import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';

export class ComponentsAppSplash extends Component {
    render() {
        if (!this.props.visible) return null;

        return (
            <div
                className="SplashScreen"
            >
                <ProgressSpinner
                    style={{ width: '130px', height: '130px' }}
                    strokeWidth="3"
                    fill="none"
                    animationDuration="2s"
                />
            </div>
        );
    }
}

